import { c as _c } from "react/compiler-runtime";
import type { XtdhReceivingProps } from "../types";
export function XtdhReceivingSection(t0) {
  const $ = _c(15);
  const {
    rate,
    totalReceived,
    totalGranted
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 id="xtdh-receiving-heading" className="tw-sr-only">Receiving from Others</h2>;
    t2 = <p className="tw-mb-2 tw-text-xs tw-font-medium tw-uppercase tw-text-iron-300" title="Your current incoming xTDH rate from other holders">Receiving from Others</p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== rate) {
    t3 = <span className="tw-font-semibold">{rate}</span>;
    $[2] = rate;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-text-iron-400"> • </span>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== totalReceived) {
    t5 = <span className="tw-font-semibold">{totalReceived}</span>;
    $[5] = totalReceived;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <p className="tw-text-sm tw-text-iron-200">{t3}{" per day"}{t4}{t5}{" total xTDH received"}</p>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== totalGranted) {
    t7 = <p className="tw-mt-1 tw-text-xs tw-text-iron-400">Total granted:{" "}<span className="tw-font-semibold tw-text-iron-200">{totalGranted}</span></p>;
    $[10] = totalGranted;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <section aria-labelledby="xtdh-receiving-heading" className="tw-mt-5">{t1}{t2}{t6}{t7}</section>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}